/* eslint-disable */
import { produce } from 'immer';
import {create} from 'zustand';

export type SellVerifyResponseData = {
  amountToPay: number;
  cess: number;
  discountAmount: number;
  discountPercent: number;
  error: string;
  gst: number;
  message: string;
  msgKey: string;
  sellLotId: string;
  total: number;
  weight: number;
};

export const SellVerifyInitialData = {
  amountToPay: 0,
  cess: 0,
  discountAmount: 0,
  discountPercent: 0,
  error: '',
  gst: 0,
  message: '',
  msgKey: '',
  sellLotId: '',
  total: 0,
  weight: 0,
};
type SellVerify = {
  option: string;
  verifyData: SellVerifyResponseData;
};

const initialState: SellVerify = {
  option: 'rupees',
  verifyData: SellVerifyInitialData,
};

export type SellVerifyStore = {
  updateOption: (option: SellVerify['option']) => void;
  updateResponse: (VerifyData: SellVerify['verifyData']) => void;
  resetSellVerifyData: () => void;
};

export const useSellVerifyStore = create<SellVerify & SellVerifyStore>(
  (set) => ({
    ...initialState,
    updateOption: (Option: string) => {
      set({
        option: Option,
      });
    },
    updateResponse: (verifyData) => {
      set(
        produce((state: SellVerify) => {
          state.verifyData = verifyData ;
        })
      );
    },
    resetSellVerifyData: () => set(initialState),
  })
);
